import { Activity } from "lucide-react";
import type { MapStyleRuntimePanelProps } from "../../contracts/map-styles";
import { cn } from "../../lib/utils";
import { MapAssetStatList } from "../map-assets/MapAssetStatList";

/**
 * A panel presenting the runtime status and authoring state of a map style.
 */
export function MapStyleRuntimePanel({
  title = "Runtime Context",
  description,
  statusBadges = [],
  summaryItems = [],
  body,
  className,
}: MapStyleRuntimePanelProps) {
  return (
    <div className={cn("flex flex-col gap-4", className)}>
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <Activity className="h-4 w-4 text-muted-foreground" />
          <h3 className="text-xs font-black uppercase tracking-wider text-foreground">
            {title}
          </h3>
        </div>
        {description && (
          <p className="text-[10px] text-muted-foreground leading-relaxed">
            {description}
          </p>
        )}
      </div>

      <div className="flex flex-wrap items-center gap-2">
        {statusBadges.map((badge) => (
          <div
            key={badge.id}
            className={cn(
              "px-2 py-0.5 rounded text-[10px] font-black uppercase tracking-widest border",
              badge.tone === "success" && "bg-success/10 text-success border-success/20",
              badge.tone === "warning" && "bg-warning/10 text-warning border-warning/20",
              badge.tone === "danger" && "bg-destructive/10 text-destructive border-destructive/20",
              badge.tone === "muted" && "bg-muted text-muted-foreground border-border",
              (!badge.tone || badge.tone === "default") && "bg-primary/10 text-primary border-primary/20"
            )}
          >
            {badge.label}
          </div>
        ))}
      </div>

      {summaryItems && summaryItems.length > 0 && (
        <div className="p-3 rounded-lg bg-background border border-border/50">
          <MapAssetStatList items={summaryItems} />
        </div>
      )}

      {body && (
        <div className="flex flex-col gap-2 p-3 rounded-lg border border-border bg-muted/5">
          {body}
        </div>
      )}
    </div>
  );
}
